import React from 'react';
import { Row } from 'react-bootstrap';
import Button from 'components/DesignSystem/Button';
import {
  useDeleteComparatorPreferencesMutation, useListComparatorPreferencesQuery,
} from 'services/api/Meteorology';
import { useHandleRequestErrors } from 'utils/hooks';
import { ResponseError } from 'services/api/base';
import useComparatorControlPanel from 'utils/hooks/meteorology/comparator/useComparatorControlPanel';
import useComparatorSavePreferencesModal from 'utils/hooks/meteorology/useComparatorSavePreferencesModal';
import useComparatorParams from 'utils/hooks/meteorology/comparator/useComparatorParams';
import useApplyComparatorOpenDefault from 'hooks/Meteorology/Fields/Comparator/useApplyComparatorOpenDefault';
import { useDispatch } from 'react-redux';
import { setTriggerActivity } from 'redux/reducers/meteorologyFieldsComparatorControlPanelReducer';
import Accordion from 'components/Accordion';
import ConfirmationModal from 'components/PreferenceDialog/Success';
import ErrorModal from 'components/PreferenceDialog/Error';
import PreferencesAccordion from './PreferencesAccordion';
import PopularComparisonsAccordion from '../PopularComparisonsAccordion';
import ModelAccordion, { ModelType } from './modelAccordion';
import SavePreferencesModal from './SavePreferencesModal';

export default function Comparator() {
  const dispatch = useDispatch();
  const { data, error } = useListComparatorPreferencesQuery();
  const preferences = data?.data || [];
  const [onPreferenceDeleteTrigger, {
    isLoading: preferenceDeleteLoading,
    error: preferenceDeleteError,
  }] = useDeleteComparatorPreferencesMutation();
  useHandleRequestErrors(error as ResponseError | undefined);
  useHandleRequestErrors(preferenceDeleteError as ResponseError | undefined);
  const { resetPreferences } = useComparatorControlPanel();
  const {
    setShowFormModal,
    isShowingConfirmationModal,
    setShowConfirmationModal,
    isShowingErrorModal,
    setShowErrorModal,
    error: saveError,
  } = useComparatorSavePreferencesModal();
  const comparatorParams = useComparatorParams();
  const queryTriggerMethod = () => dispatch(setTriggerActivity(true));

  useApplyComparatorOpenDefault();

  return (
    <div>
      <ConfirmationModal
        open={isShowingConfirmationModal}
        closing={() => { setShowConfirmationModal(false); }}
      />
      <ErrorModal
        open={isShowingErrorModal}
        message={saveError}
        closing={() => { setShowErrorModal(false); }}
      />
      <SavePreferencesModal />
      <Accordion defaultActiveKey="0">
        <PopularComparisonsAccordion />
        <PreferencesAccordion
          preferenceList={preferences}
          deleteTrigger={onPreferenceDeleteTrigger}
          deleteLoading={preferenceDeleteLoading}
        />
        <Accordion.Item eventKey="2">
          <Accordion.Header>Nova Comparação</Accordion.Header>
          <Accordion.Body>
            <ModelAccordion title="Modelo Confrontante" modelType={ModelType.CONFRONTATIONAL} />
            <ModelAccordion title="Modelo Base" modelType={ModelType.BASE} />

            <Row className="pt-5">
              <Button onClick={() => setShowFormModal(true)}>
                Salvar nova preferência
              </Button>
            </Row>
            <Row className="pt-2">
              <Button disabled={comparatorParams === undefined} onClick={queryTriggerMethod}>
                Realizar consulta
              </Button>
            </Row>
            <Row>
              <Button type="tertiary" className="clear-filters mt-1" onClick={resetPreferences}>
                Limpar filtros
              </Button>
            </Row>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}
